import SolicitacaoFaturamento from './componentes/SolicitacaoFaturamento.vue';
import SolicitacaoFaturamentoLista from './componentes/SolicitacaoFaturamentoLista.vue';
import SolicitacaoFaturamentoForm from './componentes/SolicitacaoFaturamentoForm.vue';
import SolicitacaoFaturamentoRelatorio from './componentes/SolicitacaoFaturamentoRelatorio.vue';

export default {
  path: '/solicitacao-faturamento-estrangeiro-pj',
  component: SolicitacaoFaturamento,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoFaturamentoLista,
      name: 'solicitacao-faturamento-estrangeiro-pj',
    },
    {
      path: 'nova',
      component: SolicitacaoFaturamentoForm,
      name: 'solicitacao-faturamento-estrangeiro-pj.nova'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoFaturamentoRelatorio,
      name: 'solicitacao-faturamento-estrangeiro-pj.relatorio'
    },
    {
      path: ':id',
      component: SolicitacaoFaturamentoForm,
      name: 'solicitacao-faturamento-estrangeiro-pj.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-faturamento-estrangeiro-pj/rotas.js